import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function movePtz() {
    return (
        <div data-cy="historic-icon-ipcamera-movePtz">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.ipcamera.movePtz" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faArrowsAlt} size="lg" />
            </Whisper>
        </div>
    );
}
